export const validateTournamentName = name => {
  const tournamentNameRegex = /^[a-zA-Z0-9 _\-.@#&!():]*$/;

  if (!name || name.trim() === "") {
    return "Tournament name is required";
  }

  if (!tournamentNameRegex.test(name)) {
    return "Tournament name can only contain alphanumeric characters, spaces, and these special characters: _ - . @ # & ! ( ) :";
  }

  return null;
};

export const tournamentNameYupValidation = () => {
  const tournamentNameRegex = /^[a-zA-Z0-9 _\-.@#&!():]*$/;

  return {
    matches: [
      tournamentNameRegex,
      "Tournament name can only contain alphanumeric characters, spaces, and these special characters: _ - . @ # & ! ( ) :",
    ],
  };
};
